var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2145 0.0512164C14.0324 3.35555 16.7455 6.08842 20.0511 5.9302C17.5891 8.13925 17.5751 11.9877 20.0211 14.2145C16.7168 14.0324 13.9839 16.7455 14.1421 20.0511C11.9331 17.589 8.08461 17.5751 5.85779 20.0211C6.03995 16.7168 3.3268 13.9839 0.0212323 14.1421C2.48327 11.933 2.49721 8.0846 0.0512345 5.85777C3.35556 6.03993 6.08844 3.32678 5.93022 0.0212142C8.13378 2.48323 11.9877 2.49719 14.2145 0.0512164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRockIcon);
export default __webpack_public_path__ + "static/media/whiteRockIcon.94ff7065c6709b5600c008ee9e20e808.svg";
export { ForwardRef as ReactComponent };